// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","bug":"Footer_bug__CBeea"};